import { actionTextColor } from "../utils/themeContrast";
import { requiredOptionsComplete } from "../utils/requiredOptions";
import { readableText } from "../utils/themeContrast";
import React, { forwardRef, useCallback, useImperativeHandle, useState, useRef, useEffect } from "react";
import "../styles/styles.css";
import styled from "@emotion/styled";
import MenuOptions from "./optioncomponents/MenuOptions";
import RemarksTab from "./optioncomponents/RemarksTab";
import RecommendedEngine from './RecommendedEngine';
import QuantityAdjust from "./optioncomponents/QuantityAdjust";
import TakeAwayCheckBox from "./optioncomponents/TakeAwayCheckBox";
import { ThemeContext, UserContext } from "../contexts/Context";
import { IoCloseOutline } from "react-icons/io5";
import { getMenuAvailabilityInfo } from "../utils/menuAvailability";
import { applyServiceTypePrices } from "../utils/menuPrice";
const MenuInfoContainer = ({ width, menuSelectionFormRef, selectedMenu, theme, isEdit, setShow, cp, addRecItemToCart, onAddToCart, addToCartText }) => {
  const priceFieldRef = useRef(null);
  const themeContext = React.useContext(ThemeContext);
  const { lanIndex, currencySymbol, isMenuView, tax, displayNetAmount, hidePrice, isLanReverse, company, isTakeAway, tkType, allowDineInTakeAway, hideLimitedTimeInfo } = React.useContext(UserContext);
  const [displayedMenu, setDisplayedMenu] = useState(menuSelectionFormRef.current || selectedMenu);
  const [canAdd, setCanAdd] = useState(() => requiredOptionsComplete((menuSelectionFormRef.current || selectedMenu).optionArray));
  const [itemQuantity, setItemQuantity] = useState(() => Number((menuSelectionFormRef.current || selectedMenu).qty || (menuSelectionFormRef.current || selectedMenu).minQty || 1));
  const getDisplayedPrice = item => Number(item.price || 0) * (displayNetAmount ? 1 + Number(tax.taxMode == 0 ? tax.tax : item.tax) : 1);
  const [unitPrice, setUnitPrice] = useState(() => getDisplayedPrice(menuSelectionFormRef.current || selectedMenu));
  const updateCompletion = useCallback(() => {
    setCanAdd(requiredOptionsComplete(menuSelectionFormRef.current.optionArray));
  }, [menuSelectionFormRef]);
  const availabilityInfo = hideLimitedTimeInfo ? null : getMenuAvailabilityInfo(displayedMenu);

  useEffect(() => {
    const item = menuSelectionFormRef.current || selectedMenu;
    setDisplayedMenu(item);
    setItemQuantity(Number(item.qty || item.minQty || 1));
    setCanAdd(requiredOptionsComplete(item.optionArray));
  }, [selectedMenu, menuSelectionFormRef]);
  //Method
  const adjustQuantity = useCallback((value) => {
    menuSelectionFormRef.current.qty = value;
    setItemQuantity(Number(value));
  }, [menuSelectionFormRef]);
  const setTakeAway = (value) => {
    let updatedItem = menuSelectionFormRef.current;
    if (company && company.hasCombineMenu) {
      updatedItem = applyServiceTypePrices(updatedItem, value ? 0 : 1);
    }
    updatedItem.isTakeAway = value;
    menuSelectionFormRef.current = updatedItem;
    setDisplayedMenu(updatedItem);
    setUnitPrice(getDisplayedPrice(updatedItem));
  }
  const adjustRemark = (value) => {
    menuSelectionFormRef.current.remark = value;
  };
  const setPriceMethod = useCallback((value) => {
    setUnitPrice(Number(value));
    if (!hidePrice && priceFieldRef.current) {
      priceFieldRef.current.setPrice(value);
    }
  }, [hidePrice]);
  const setComparePriceMethod = useCallback((value) => {
    if (!hidePrice && value !== null && typeof value !== "undefined" && priceFieldRef.current) {
      priceFieldRef.current.setComparePrice(value);
    }
  }, [hidePrice]);

  return (
    <MenuInfoShell>
      {isEdit &&
        <IconButton type="button" aria-label="Close item details" onClick={() => setShow(false)} themeContext={themeContext}>
          <IoCloseOutline size={22} aria-hidden="true" />
        </IconButton>
      }
    <MenuInfoLayout data-option-flow themeContext={themeContext}>
      <ItemDisplay
        title={(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? displayedMenu.title : displayedMenu.title2 ? displayedMenu.title2 : displayedMenu.title}
        image={displayedMenu.image}
        themeContext={themeContext}
        theme={theme}
        isEdit={isEdit}
        height={(width) / 4 * 3}
      ></ItemDisplay>
      <DetailsPane>
        <OptionsDisplay width={width} isEdit={isEdit} themeContext={themeContext} theme={theme}>
          <MenuInfoHeaderContainer>
            <TitleContainer
              themeContext={themeContext}
              itemTitle={(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? displayedMenu.title : displayedMenu.title2 ? displayedMenu.title2 : displayedMenu.title}
            >{`${(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? displayedMenu.title : displayedMenu.title2 ? displayedMenu.title2 : displayedMenu.title}`}</TitleContainer>
            {!hidePrice &&
              <PriceField key={`${displayedMenu.codeId}-${displayedMenu.isTakeAway}`} ref={priceFieldRef} selectedMenu={displayedMenu} currencySymbol={currencySymbol} />
            }
          </MenuInfoHeaderContainer>
          <DescriptionContainer themeContext={themeContext}>
            <DescriptionText>
              {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? displayedMenu.description : displayedMenu.description2 ? displayedMenu.description2 : displayedMenu.description}
              {(company._id == "677ae529d90797dc89c7091a" ||
                company._id == "6805bc98e75fb1ce8570ff56" ||
                company._id == "684f18fd6e9f70e3c736d85d" ||
                company._id == "699d1acc1523f7fcac052961" ||
                company._id == "68c3e1fa1b4ff1ed132de4b4" ||
                company._id == "6a0e7102403c628d1dcc9e74"
              ) && displayedMenu.description2 && displayedMenu.description2.length > 0 ? <><br /><br />{displayedMenu.description2}</> : ""}
            </DescriptionText>
            {availabilityInfo &&
              <AvailabilityBadge isUnavailable={availabilityInfo.isUnavailable}>
                {availabilityInfo.text}
              </AvailabilityBadge>
            }
          </DescriptionContainer>
          {displayedMenu.optionArray.map((item, index) => (
            item.options && item.options.length > 0 ?
              <MenuOptions
                onSelectionChange={updateCompletion}
                key={`${item.optionTitle}-${index}-${displayedMenu.isTakeAway}`}
                selectedMenu={displayedMenu}
                menuIndex={index}
                menuSelectionFormRef={menuSelectionFormRef}
                menuOptions={item}
                setPrice={setPriceMethod}
                setComparePrice={setComparePriceMethod}
                isSetMeal={displayedMenu.isSetMeal}
                fixedPrice={displayedMenu.fixedPrice}
                cp={cp}
              />
              :
              <></>
          ))}
          {/* Takeaway Component */}
          {allowDineInTakeAway && (tkType == 1 || !isTakeAway) && !Boolean(menuSelectionFormRef.current.notForTakeAway) &&
            <TakeAwayCheckBox
              index={-1}
              lanIndex={lanIndex}
              isTakeAway={Boolean(menuSelectionFormRef.current.isTakeAway)}
              setTakeAway={setTakeAway}
            />
          }
          {/* Remarks Component */}
          {!isMenuView && (menuSelectionFormRef.current && menuSelectionFormRef.current.hasRemark) ? (
            <RemarksTab
              lanIndex={lanIndex}
              state={menuSelectionFormRef.current.remark}
              setState={adjustRemark}
            />
          ) : (
            <React.Fragment />
          )}
          {(!isEdit && menuSelectionFormRef.current && menuSelectionFormRef.current.recommendedEngine && menuSelectionFormRef.current.recommendedEngine.length > 0) &&
            <RecommendedEngine
              lanIndex={lanIndex}
              codeId={menuSelectionFormRef.current.codeId}
              recommendedEngine={JSON.parse(JSON.stringify(menuSelectionFormRef.current.recommendedEngine))}
              addRecItemToCart={addRecItemToCart}
            />

          }
        </OptionsDisplay>
        {!isMenuView &&
          <ModalActionFooter themeContext={themeContext}>
            {!displayedMenu.hideQtySelection &&
              <QuantityAdjust
                compact
                size={36}
                lanIndex={lanIndex}
                quantity={menuSelectionFormRef.current && menuSelectionFormRef.current.qty ? menuSelectionFormRef.current.qty : (menuSelectionFormRef.current && menuSelectionFormRef.current.minQty ? menuSelectionFormRef.current.minQty : 1)}
                minQty={menuSelectionFormRef.current && menuSelectionFormRef.current.minQty ? menuSelectionFormRef.current.minQty : 1}
                adjustQuantity={adjustQuantity}
              />
            }
            <ModalAddButton type="button" themeContext={themeContext} disabled={!canAdd} onClick={() => {
              if (requiredOptionsComplete(menuSelectionFormRef.current.optionArray) && onAddToCart) onAddToCart();
            }}>
              <span>{addToCartText || "Add to order"}</span>
              {!hidePrice && <span>{currencySymbol}{(unitPrice * itemQuantity).toFixed(2)}</span>}
            </ModalAddButton>
          </ModalActionFooter>
        }
      </DetailsPane>
    </MenuInfoLayout>
    </MenuInfoShell>
  );
};
export default MenuInfoContainer;

export const PriceField = forwardRef((props, ref) => {
  const { tax, displayNetAmount, customer } = React.useContext(UserContext);

  const [priceHolder, setPriceHolder] = useState(
    (props.selectedMenu.price * (displayNetAmount ? (1 + (tax.taxMode == 0 ? tax.tax : props.selectedMenu.tax)) : 1)).toFixed(2)
  );
  const [priceCompareHolder, setPriceCompareHolder] = useState("");
  const [pbTitle, setPbTitle] = useState("");
  const themeContext = React.useContext(ThemeContext);

  useImperativeHandle(ref, () => ({
    setPrice: setPriceHolder,
    setComparePrice: setPriceCompareHolder
  }), []);

  useEffect(() => {
    let comparePrice = "";
    if (props.selectedMenu.comparePrice) {
      comparePrice = (props.selectedMenu.comparePrice * (displayNetAmount ? (1 + (tax.taxMode == 0 ? tax.tax : props.selectedMenu.tax)) : 1)).toFixed(2);
    } else if (props.selectedMenu.pricebook && Object.keys(props.selectedMenu.pricebook).length > 0) {
      let bp = props.selectedMenu.pricebook[Object.keys(props.selectedMenu.pricebook)[0]];

      if (bp.minQty == 1) {
        comparePrice = (bp.price * (displayNetAmount ? (1 + (tax.taxMode == 0 ? tax.tax : props.selectedMenu.tax)) : 1)).toFixed(2);
        setPbTitle(bp.title);
      }
    }
    setPriceCompareHolder(comparePrice);

  }, []);

  return (
    <PriceWapper themeContext={themeContext}>

      {(typeof props.selectedMenu.comparePrice != 'undefined' && props.selectedMenu.comparePrice > 0) &&
        <PriceCompareContainer themeContext={themeContext}>
          {`${props.currencySymbol} ${priceCompareHolder}`}
        </PriceCompareContainer>
      }
      {(!props.selectedMenu.isSetMeal ||
        (props.selectedMenu.isSetMeal && props.selectedMenu.optionArray.length > 0 &&
          props.selectedMenu.optionArray[0].optionType != 5)) &&
        <PriceContainer themeContext={themeContext} hasCustomer={customer && pbTitle}>
          {`${pbTitle ? "ORI: " : ""}${props.currencySymbol} ${priceHolder}`}
        </PriceContainer>
      }
      {(typeof props.selectedMenu.pricebook != 'undefined' && Object.keys(props.selectedMenu.pricebook).length > 0) &&
        <PriceBookContainer themeContext={themeContext}>
          {`${pbTitle}: ${props.currencySymbol} ${priceCompareHolder}`}
        </PriceBookContainer>
      }
    </PriceWapper>
  );
});
PriceField.displayName = "PriceField";

const IconButton = styled.button`
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  width: 36px;
  height: 36px;
  padding: 0;
  align-items: center;
  justify-content: center;
  z-index: 5;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  color: #fff;
  background: rgba(35, 28, 24, 0.72);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  &:hover { background: rgba(35, 28, 24, 0.9); }
  &:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }
`;

const MenuInfoShell = styled.div`
  position: relative;
  width: 100%;
  min-height: 0;
  overflow: hidden;
`;

const MenuInfoLayout = styled.div`
  position: relative;
  display: flex;
  height: var(--item-detail-height, 100dvh);
  min-height: 0;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  width: 100%;
  background: ${(props) => props.themeContext.backgroundColor};

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: minmax(0, 52%) minmax(0, 48%);
    height: min(760px, calc(100dvh - 80px));
    min-height: 0;
    overflow: hidden;
  }
`;

const DetailsPane = styled.div`
  display: flex;
  flex: 1 0 auto;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  overflow: visible;

  @media (min-width: 768px) {
    flex: 1 1 auto;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    overscroll-behavior: contain;
  }
`;

const ModalActionFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  gap: 10px;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 12px;
  align-items: center;
  background: ${(props) => props.themeContext.backgroundColor};
  border-top: 1px solid ${(props) => props.themeContext.borderColor || "#ddd"};
  box-shadow: 0 -5px 14px rgba(0, 0, 0, 0.06);

  @media (min-width: 768px) {
    flex: 0 0 auto;
    padding: 10px 16px;
  }
`;

const ModalAddButton = styled.button`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  height: 48px;
  padding: 0 18px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid ${props => props.themeContext.primaryColor};
  border-radius: 999px;
  color: ${props => actionTextColor(props.themeContext)};
  background: ${props => props.themeContext.primaryColor};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease;
  span:last-child { white-space: nowrap; }
  &:disabled { color: #909090; background: #ededed; border-color: #ddd; cursor: not-allowed; }
`;

const PriceWapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${props => props.themeContext.primaryColor};
  font-weight: 500;
  font-family: ${props => props.themeContext.fontFamily};
  text-align: left;
  line-height: 1.4;
`;
const PriceCompareContainer = styled.div`
  text-decoration: line-through;
  font-size: 14px;
 
`;
const PriceContainer = styled.div`
  
  font-size: ${(props) => (props.hasCustomer ? "14" : "16")}px;
  text-decoration: ${(props) => (props.hasCustomer ? "line-through" : "none")};
`;
const PriceBookContainer = styled.div`
  font-size: 16px;
`;

const ItemDisplay = styled.div`
  display: block;
  flex: 0 0 auto;
  text-align: center;
  margin-bottom: 0;
  height:  ${(props) => props.theme == 3 || props.isEdit ? props.height + "px" : "300px"};
  max-height: 350px;
  //Adjust the image height to be adjusted based on the screen size at a later date.
  background-image: url(${(props) => props.image});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  animation: itemPic .15s;
  animation-timing-function: ease-out;
  @keyframes itemPic {
    0%  {
      opacity:0.3;
      transform: translateY(-40px);
    }
    
    100%  {
      opacity:1;
      transform: translateY(0px);
    }
    
  }

  @media (min-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: none;
    margin-bottom: 0;
  }
`;

const OptionsDisplay = styled.div`
  display: block;
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: visible;
  text-align: center;
  background-color: ${(props) => props.themeContext.backgroundColor};
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 20px;
  margin-top: ${(props) => props.theme == 3 || props.isEdit ? "0px" : "-50px"};
  bottom: 0px;
  //Temp Height, remove at commit, adjust min height, maybe based on screensize??
  //Probably going to require a tablet build at a certain point.
  animation: itemTxt .2s;
  animation-timing-function: ease-out;
  padding-bottom: 24px;
  @media (min-width: 768px) {
    align-content: flex-start;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 0;
    padding: 24px 24px 0;
    border-radius: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 0px;
  }
  @keyframes itemTxt {
    0%  {
      transform: translateY(20px);
    }
    
    100%  {
      transform: translateY(0px);
    }
    
  }
  
`;

const MenuInfoHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 16px 16px 0;
  @media (min-width: 768px) {
    margin: 0;
    padding-right: 36px;
    gap: 8px;
  }
`;

const TitleContainer = styled.div`
  color: ${props => props.themeContext.fontPrimary};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
  overflow-wrap: anywhere;
  @media (min-width: 768px) { font-size: 24px; }
`;
const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 16px 24px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  white-space: pre-wrap;
  color: ${props => props.themeContext.descriptionColor || props.themeContext.fontPrimary};
  @media (min-width: 768px) { margin: 12px 0 24px; font-size: 14px; }
`;

const DescriptionText = styled.div`
  display: block;
`;

const AvailabilityBadge = styled.div`
  width: fit-content;
  max-width: calc(100% - 10px);
  margin-top: 8px;
  padding: 6px 8px;
  border-radius: 5px;
  white-space: normal;
  color: ${(props) => props.isUnavailable ? "#9a4b00" : "#0f6b35"};
  background-color: ${(props) => props.isUnavailable ? "rgba(255, 152, 0, 0.14)" : "rgba(29, 145, 74, 0.14)"};
  border: 1px solid ${(props) => props.isUnavailable ? "rgba(255, 152, 0, 0.55)" : "rgba(29, 145, 74, 0.55)"};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
`;
